export default __webpack_public_path__ + "static/media/7lg.0214dc5f.svg";